import { defineStore } from "pinia";
import User from "../utilities/User"
import { BACKEND_URL } from '../variables.js'
import axios from 'axios'
import 'regenerator-runtime'
import { useLocalStorage } from "@vueuse/core"

export const useUserStore = defineStore("UserStore", {
    // viewerOnly: signed in to Drupal (LinkedIn) but holding no RPD role. Set by
    // checkLogin() on every call. Such a reader may open the public Quarterly
    // Trending Analysis page and nothing else.
    state: () => ({ current_user: new User(), viewerOnly: false, userGutSelected: useLocalStorage('userGutSelected', new Array(), { mergeDefaults: true }) }),
    actions: {
        setUser(bc_access, first_name, last_name, mail, role, status, uid, access = null, is_super_admin = undefined) {
            this.current_user = new User(bc_access, first_name, last_name, mail, role, status, uid, access, is_super_admin)
        },
        async checkLogin() {
            try {
                let res = await Promise.all([axios.get(BACKEND_URL + 'api/current_user'), axios.get(BACKEND_URL + 'api/get_role')]);
                let loggedIn = false
                let hasSession = false

                res.forEach(x => {
                    if (x.data.status == 1) hasSession = true
                    if (x.data.role != "" && x.data.role != undefined) {
                        if (x.data.status == 1) {
                            this.setUser(x.data.bcaccess, x.data.first_name, x.data.last_name, x.data.mail, x.data.role, x.data.status, x.data.uid, x.data.access || null, x.data.is_super_admin)
                        } else {
                            this.current_user.role = x.data.role
                        }
                        loggedIn = true
                    }
                })

                this.viewerOnly = !loggedIn && hasSession
                // Drop a user persisted from an earlier RPD sign-in in this
                // browser, so role checks cannot read someone else's role.
                if (this.viewerOnly) this.current_user = new User()

                return loggedIn
            } catch (error) {
                throw error
            }
        },

        getUser() {
            return this.current_user
        },
    },
    getters: {
        isLogin(state) {
            if (state.current_user.status || state.current_user.status != undefined)
                return true

            return false
        }

    },
    persist: true,

}) 